export default __webpack_public_path__ + "static/media/1856.bf787c73.png";